import {UserAvatar} from './user_avatar'
import {User} from '@eitje/api'

export const UserAvatarWithUserId = ({userId, ...rest}) => {
	const user = User.useFind(userId)
	return <UserAvatar user={user} {...rest} />
}
